module.exports = __webpack_public_path__ + "img/message.1fbaa155.svg";